<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />

    <Breadcrumb :links="breadCrumbData" />

    <Carrusel />

    <h3 class="text-indicator">Incentivo Institucional</h3>
    <!-- <div v-if="permiso">
      <div v-if="datos"> -->
    <!-- <Table :listData="listData" /> -->
    <!-- <Upload /> -->
    <!-- </div>
      <div v-else> -->
    <!-- <Upload /> -->
    <!-- <div class="main-text"> -->
    <!-- <h6>
            Antes de comenzar descarga el formato de archivos que debes subir
            para completar el módulo.
          </h6> -->
    <!-- </div>
      </div>
    </div> -->
    <!-- 
    <div v-else> -->
    <div v-if="datos">
      <h3 class="title">
        INFORME DE CUMPLIMIENTO DEL PROGRAMA DE MEJORAMIENTO DE LA GESTIÓN AÑO
        {{ anio }}
      </h3>

      <section class="container">
        <b-row>
          <b-col cols="8">
            <div class="div">
              <span class="title"
                >MINISTERIO:
                <span class="text">{{ listData[0].ministerio }}</span></span
              >
            </div>
            <div class="div">
              <span class="title"
                >SERVICIO: <span class="text"></span
                >{{ listData[0].servicio }}</span
              >
            </div>
            <div class="div">
              <span class="title"
                >DOTACIÓN:
                <span class="text">{{ listData[0].dotacion }}</span></span
              >
            </div>
          </b-col>
          <b-col cols="4">
            <div class="div">
              <span class="title"
                >PARTIDA PRESUPUESTARIA:
                <span class="text">{{ listData[0].cPartida }}</span></span
              >
            </div>
            <div class="div">
              <span class="title"
                >CAPÍTULO PRESUPUESTARIO:
                <span class="text">{{ listData[0].cCapitulo }}</span></span
              >
            </div>
          </b-col>
        </b-row>

        <b-row>
          <h4>OBJETIVOS DE GESTIÓN</h4>
          <div class="container">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Objetivos de Gestión</th>
                  <th scope="col">N° Indicadores comprometidos</th>
                  <th scope="col">% Ponderación Comprometida</th>
                  <th scope="col">% Ponderación obtenida</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ listData[0].objetivo1 }}</td>
                  <td class="td-table">{{ listData[0].cantidadObj1 }}</td>
                  <td class="td-table">{{ listData[0].ponderadorObj1 }}</td>
                  <td class="td-table">{{ listData[0].obtenidoObj1 }}</td>
                </tr>
                <tr>
                  <td>{{ listData[0].objetivo2 }}</td>
                  <td class="td-table">{{ listData[0].cantidadObj2 }}</td>
                  <td class="td-table">{{ listData[0].ponderadorObj2 }}</td>
                  <td class="td-table">{{ listData[0].obtenidoObj2 }}</td>
                </tr>
                <tr>
                  <td>{{ listData[0].objetivo3 }}</td>
                  <td class="td-table">{{ listData[0].cantidadObj3 }}</td>
                  <td class="td-table">{{ listData[0].ponderadorObj3 }}</td>
                  <td class="td-table">{{ listData[0].obtenidoObj3 }}</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td class="td-table">
                    {{ listData[0].TotalCantidadIndicadores }}
                  </td>
                  <td class="td-table">{{ listData[0].TotalPonderador }}</td>
                  <td class="td-table">{{ listData[0].TotalObtenido }}</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-striped">
              <thead>
                <tr>
                  <th>N°</th>
                  <th>Nombre Indicador</th>
                  <th>COMPROMISO / META {{ anio }}</th>
                  <th>EFECTIVO {{ anio }}</th>
                  <th>CUMPLIMIENTO</th>
                  <th>Ponderación comprometida {{ anio }}</th>
                  <th>Ponderación obtenida {{ anio }}</th>
                </tr>
                <tr class="tr-Two" style="">
                  <th style="color:#052333; text-align: left" colspan="5">
                    Objetivo 1: Gestión Eficaz
                  </th>

                  <th style="color:#052333">{{ listData[0].ponderadorObj1 }}%</th>
                  <th style="color:#052333">{{ listData[0].obtenidoObj1 }}%</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, gestion) in gestion" :key="gestion">
                  <td>{{ gestion + 1 }}</td>
                  <td>{{ item.nombreIndicador }}</td>
                  <td>{{ item["v meta"] }}</td>
                  <td>{{ item.efectivo2020 }}</td>
                  <td>{{ item.cumplimiento }}</td>
                  <td>{{ item.pondIncentivo }}%</td>
                  <td>{{ item["ponderacion_ finalIncentivo"] }}%</td>
                </tr>

                <tr class="tr-Two" style="">
                  <th style="color:#052333; text-align: left" colspan="5">
                    Objetivo 2: Eficiencia Institucional
                  </th>

                  <th style="color:#052333">{{ listData[0].ponderadorObj2 }}%</th>
                  <th style="color:#052333">{{ listData[0].obtenidoObj2 }}%</th>
                </tr>
                <tr v-for="(item, eficiencia) in eficiencia" :key="eficiencia">
                  <td>{{ eficiencia + 1 }}</td>
                  <td>{{ item.nombreIndicador }}</td>
                  <td>{{ item["v meta"] }}</td>
                  <td>{{ item.efectivo2020 }}</td>
                  <td>{{ item.cumplimiento }}</td>
                  <td>{{ item.pondIncentivo }}%</td>
                  <td>{{ item["ponderacion_ finalIncentivo"] }}%</td>
                </tr>

                <tr class="tr-Two" style="">
                  <th style="color:#052333; text-align: left" colspan="5">
                    Objetivo 3: Calidad de los Servicios
                  </th>

                  <th style="color:#052333">{{ listData[0].ponderadorObj3 }}%</th>
                  <th style="color:#052333">{{ listData[0].obtenidoObj3 }}%</th>
                </tr>

                <tr v-for="(item, calidad) in calidad" :key="calidad">
                  <td>{{ calidad + 1 }}</td>
                  <td>{{ item.nombreIndicador }}</td>
                  <td>{{ item["v meta"] }}</td>
                  <td>{{ item.efectivo2020 }}</td>
                  <td>{{ item.cumplimiento }}</td>
                  <td>{{ item.pondIncentivo }}%</td>
                  <td>{{ item["ponderacion_ finalIncentivo"] }}%</td>
                </tr>
                <tr>
                  <th colspan="4" style="color:#052333; text-align: left">
                    Porcentaje de Cumplimiento Global
                  </th>
                  <th colspan="3">{{ listData[0].TotalObtenido }}%</th>
                </tr>
                <tr>
                  <th colspan="4" style="color:#052333; text-align: left">
                    Porcentaje de incremento por desempeño institucional
                  </th>
                  <th colspan="3">
                    {{
                      listData[0]
                        .porcentajeDeIncrementoPorDesempeñoInstitucional
                    }}
                  </th>
                </tr>

                <tr>
                  <td colspan="7">
                    {{ listData[0].resultadoFinal }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-row>
      </section>

      <!-- <Table :listData="listData" /> -->
    </div>

    <div v-else>
      <NoData />
      <br />
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import Carrusel from "../../../components/private/Carrusel.vue";
// import Table from "./main/Table.vue";
// import Main from "./main/Main.vue";
import { mapState } from "vuex";
import axios from "axios";
import NoData from "../../indicador/components/NoData.vue";
// import Upload from "./main/Upload.vue";
import { showAlert } from "../../../components/tools/utils";

export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    // Table,
    NoData,
    // Upload,
    // Main,
  },
  data() {
    return {
      permiso: true,
      breadCrumbData: null,
      listData: [],
      anio: `${process.env.VUE_APP_ANIO}`,
      datos: false,
      gestion: [],
      eficiencia: [],
      calidad: [],
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Incentivo Institucional",
          routeName: "iinstitucional",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },

    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 4) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4
      ) {
        this.permiso = true;
      }
    },

    obtenerContenido: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=7&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        const data =
          res.data[0].datos.modificado[`${process.env.VUE_APP_ANIO}`];
        this.listData = data;
        this.datos = true;
        if (this.listData === undefined) {
          this.datos = false;
          return;
        }

        this.gestion = this.listData.filter(
          (g) => g.cabeceraObjetivo === "Objetivo 1: Gestión Eficaz"
        );

        this.eficiencia = this.listData.filter(
          (g) => g.cabeceraObjetivo === "Objetivo 2: Eficiencia Institucional"
        );
        this.calidad = this.listData.filter(
          (g) => g.cabeceraObjetivo === "Objetivo 3: Calidad de los Servicios"
        );
        console.log("Datosfinales", this.listData);
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerContenido();
    this.obtenerRelacionUsuarioServicio();
    showAlert({
      icon: "success",
      text: "Espere un momento mientras carga los datos",
      timerProgressBar: true,
      timer: 5000,
    });
  },
};
</script>

<style scoped>
.text-indicator {
  text-align: center;
  font-weight: bold;
}

.title {
  text-align: center;
  font-size: 15px;
  color: #052333;
  font-weight: 600;
}

.main-text {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #b8f4e9;
  height: 50px;
}
.main-text > h6 {
  font-weight: bold;
  color: #515151;
  margin: 0;
  text-align: center;
  margin: 15px;
}

.row {
  margin: 0;
}

h4 {
  font-size: 14px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
}

.text {
  color: #052333;
  font-size: 13px;
  font-weight: 400;
}

td {
  text-align: left !important;
}

.tr-Two {
  background: #f7f7f7;
}

.tr-two:hover {
  background: #052333 !important;
}

.td-table {
  text-align: center !important;
}

.td-table-end {
  text-align: center;
  font-weight: bold;
}
</style>
